import React, { Component } from 'react'
import style from './style.module.less'
import { observer, inject } from 'mobx-react'
import { Drawer, Upload, message, Spin, Select, Button } from 'hljd'
import { SOURCE_LIST } from '../../constant'
import http from '@core/fetch'
import isEmpty from 'lodash/isEmpty'

const Option = Select.Option
const Dragger = Upload.Dragger

@inject('listStore')
@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      fileList: [],
      source: ''
    }
  }

  changeSource = source => {
    this.setState({ source })
  }

  importCSV = async () => {
    const store = this.props.listStore
    const { fileList, source } = this.state

    if (!source) {
      return message.warn('请选择来源')
    }

    if (isEmpty(fileList)) {
      return message.warn('请导入csv文件')
    }

    this.setState({ loading: true })
    const { success } = await http.post(
      '/p/wedding/Admin/APICrmMerchantCustomer/BatchImport',
      {
        body: {
          file: fileList[0],
          source: this.state.source
        },
        bodyType: 'file'
      }
    )

    this.setState({ loading: false })
    if (success) {
      message.success('导入成功')
      store.setStoreData([{ type: 'uploadVisible', value: false }])
      store.$getList(1)
    }
  }

  render() {
    const { listStore: store } = this.props
    const { uploadVisible } = store
    const { loading, fileList } = this.state

    const props = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file)
          const newFileList = state.fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        if (!isEmpty(this.state.fileList)) {
          message.warn('只能上传一个csv文件')
          return false
        }

        this.setState(state => ({
          fileList: [...state.fileList, file]
        }))
        return false
      },
      fileList
    }

    return (
      <Drawer
        title="批量导入"
        width={418}
        visible={uploadVisible}
        onClose={() =>
          store.setStoreData([{ type: 'uploadVisible', value: false }])
        }
        className={style['upload-drawer-wrap']}
        zIndex={1001}
      >
        <div className="info">
          <h3>注意事项：</h3>
          <p>
            1.需要按照模板示意的标准格式进行导入，不满足条件的数据无法成功导入
          </p>
          <p>2.使用手机号作为去重ID，如果手机号码相同，将更新对应的信息</p>
          <p>
            3.<a
              href="https://qnm.hunliji.com/加盟店客资导入.csv"
              target="__blank"
            >
              模板文件下载
            </a>
          </p>
        </div>

        <div>
          <span>来源：</span>
          <Select
            style={{ width: 200, marginBottom: 20 }}
            onChange={this.changeSource}
            placeholder="请选择"
          >
            {SOURCE_LIST.map(({ id, title }) => (
              <Option key={id} value={id}>
                {title}
              </Option>
            ))}
          </Select>
        </div>

        <Spin spinning={loading}>
          <Dragger {...props}>
            <div className="dragger-box">
              <div>
                <h3>csv文件</h3>
                <p>
                  支持拖入文件，或<a>手动选择</a>
                </p>
              </div>
            </div>
          </Dragger>
        </Spin>

        <div className="text-right">
          <Button type="primary" onClick={() => this.importCSV()}>
            上传
          </Button>
        </div>
      </Drawer>
    )
  }
}

export default Index
